export default function UserViewModal({ open, onClose, loading, user }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/30 grid place-items-center p-4">
      <div className="w-full max-w-lg bg-white rounded-2xl border p-5 max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between">
          <div className="text-lg font-bold">User Details</div>
          <button onClick={onClose} className="text-sm px-3 py-1 rounded-lg hover:bg-gray-100">
            Close
          </button>
        </div>

        <div className="mt-4">
          {loading ? (
            <div className="text-sm text-gray-600">Loading...</div>
          ) : !user ? (
            <div className="text-sm text-gray-600">No data</div>
          ) : (
            <div className="space-y-2 text-sm">
              <Row label="User ID" value={user.user_id} />
              <Row label="Name" value={[user.first_name, user.last_name].filter(Boolean).join(" ") || "-"} />
              <Row label="Email" value={user.email || "-"} />
              <Row label="Mobile" value={user.mobile_no || "-"} />
              <Row label="Role ID" value={String(user.role_id ?? "-")} />
              <Row label="Status" value={Number(user.status) === 1 ? "Active" : "Inactive"} />
              <Row label="Reason" value={user.reason || "-"} />
              <Row label="Created" value={user.created_at ? new Date(user.created_at).toLocaleString() : "-"} />
              <Row label="Updated" value={user.updated_at ? new Date(user.updated_at).toLocaleString() : "-"} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex items-start justify-between gap-4 border-b pb-2">
      <div className="text-gray-600">{label}</div>
      <div className="font-semibold text-right break-all">{value}</div>
    </div>
  );
}
